export const GET_BOOKMARKS = 'GET_BOOKMARKS';
export function getBookmarksAction(bookmarks) {
  return {
    type: GET_BOOKMARKS,
    payload: bookmarks.data,
  };
}
